document.addEventListener('DOMContentLoaded', function() {

  // var API_KEY = 'AIzaSyC53q8zAW5bqgkUoBz6Y3nU52CfsK8d0bI'
  // var CALENDAR_ID = 'v534qac1s9d26brdinkfkf4h94@group.calendar.google.com';
  var API_KEY = 'AIzaSyCVZwXKOyhlwkqm3dxzTShjYzT1NC_TQtw'
  var CALENDAR_ID = '0f2944916b10395c5370f73e2a3f6dd2514c1318525b3dc8e9c3a5f072b5ba9b@group.calendar.google.com';

  // 今日の日付を取得
  var current_date = new Date(); 
  var current_year = current_date.getFullYear();
  var current_month = current_date.getMonth() + 1;
  var current_day = current_date.getDate();
  var current_hours = current_date.getHours()
  var current_minutes = current_date.getMinutes()
  var current_dt = current_year + '-' + ( '00' + current_month ).slice( -2 ) + '-' + ( '00' + current_day ).slice( -2 );
  var time_min = current_year + '-' + ( '00' + current_month ).slice( -2 ) + '-' + ( '00' + current_day ).slice( -2 ) + 'T00:00:00+09:00';

  // 翌月の取得
  var next_date = new Date(current_year, current_month + 1, 0);
  var next_year = next_date.getFullYear();
  var next_month = next_date.getMonth() + 1;
  var next_day = next_date.getDate();
  var next_dt = next_year + '-' + ( '00' + next_month ).slice( -2 ) + '-' + ( '00' + next_day ).slice( -2 );
  var time_max = next_year + '-' + ( '00' + next_month ).slice( -2 ) + '-' + ( '00' + next_day ).slice( -2 ) + 'T00:00:00+09:00';

  //
  var day_count = (new Date(next_dt) - new Date(current_dt)) / 86400000;

  //
  var base_array = [];
  base_array.push(current_dt);
  for (var i = 0; day_count > i; i++) {
    var base_date = new Date( current_date.setDate( current_date.getDate() + 1 ) );
    var base_year = base_date.getFullYear();
    var base_month = base_date.getMonth() + 1;
    var base_day = base_date.getDate();
    var base_dt = base_year + '-' + ( '00' + base_month ).slice( -2 ) + '-' + ( '00' + base_day ).slice( -2 );
    base_array.push(base_dt);
  }

  //
  function start() {
    gapi.client.init({
      'apiKey': API_KEY,
    }).then( function() {
      return gapi.client.request({
        'path': 'https://www.googleapis.com/calendar/v3/calendars/' + encodeURIComponent(CALENDAR_ID) + '/events',
        params: { orderBy: 'startTime', singleEvents: true, timeMax: time_max, timeMin: time_min }
      })
    }).then( function( response ) {
      // 休業日の配列の作成
      var event_array = [];
      for ( var i = 0; response.result.items.length > i; i++ ) {
        event_array.push( response.result.items[i].start.date );
      }
      // 営業日を付加した配列の作成
      var store_array = [];
      for ( var i = 0; base_array.length > i; i++ ) {
        if ( event_array.indexOf( base_array[i] ) == -1 ) {
          store_array.push( base_array[i] + ':Y' );
        } else {
          store_array.push( base_array[i] + ':N' );
        }
      }
      // 配送可能日の配列の作成
      for ( var i = 0; store_array.length > i; i++ ) {
        if ( store_array[i].split( ':' )[1] == 'Y' ) {
          if ( i == 0 ) {
            var base_hm = String( ( '00' + current_hours ).slice( -2 ) ) + String(( '00' + current_minutes ).slice( -2 ));
            if ( Number( base_hm ) < 1157 ) {
              base_array.shift();
              break;
            } else {
              base_array.shift();
            }
          } else {
            base_array.shift();
            break;
          }
        } else {
          base_array.shift();
        }
      }
      //
      var weekday = [ "日", "月", "火", "水", "木", "金", "土" ];
      var delivery_array = [];
      for ( var i = 0; base_array.length > i; i++ ) {
        var delivery_date = new Date( base_array[i] );
        var delivery_year = delivery_date.getFullYear();
        var delivery_month = delivery_date.getMonth() + 1;
        var delivery_day = delivery_date.getDate();
        var delivery_week = weekday[delivery_date.getDay()]
        var delivery_value = delivery_year + '-' + (  '00' + delivery_month ).slice( -2 ) + '-' + (  '00' + delivery_day ).slice( -2 );
        var delivery_innerHTML = delivery_month + '月' + delivery_day + '日 (' + delivery_week + ')';
        var delivery_dt = delivery_value + ':' + delivery_innerHTML;
        delivery_array.push( delivery_dt );
      }
      var delivery_date = document.getElementById( 'delivery_date' );
      delivery_array.forEach( element => {
        var element_array = element.split( ':' );
        var option = document.createElement( 'option' );
        option.value = element_array[0];
        option.innerHTML = element_array[1];
        delivery_date.appendChild(option);
      });
      //
      var default_value = document.getElementById( 'dumy_delivery_date' ).value;
      if ( default_value != "" ) {
        var select = document.getElementById( 'delivery_date' );
        for ( var i = 0; i < select.options.length; i++ ) {
          if ( select.options[i].value == default_value ) {
            select.options[i].selected = true;
          }
        }
      }
      //
      delivery_date.disabled = false;
    }, function(reason) {
      console.log('Error: ' + reason.result.error.message);
    });
  }

  //
  function new_array( holiday_array ) {
    if ( holiday_array.indexOf( base_array[0] ) > -1 ) {
      base_array.shift();
      return new_array( holiday_array );
    } else {
      return;
    }
  }

  //
  gapi.load('client', start);

});

function test( old_array, ent_array) {}